import React, { useState, useContext } from "react";
import PageHeader from "../pageheader/PageHeader";
import MenuAdmin from "./navAdmin/Menu";

import styles from "./AddLabTestData.module.css";
import Input from "../material/input/Input";

import plusSmall from "../../asset/icon/plus-small.svg";

import { PlusIcon, MinusIcon } from "@heroicons/react/24/outline";
import { useEffect } from "react";

import * as AdminApi from "../../service/adminApi";
import { useLocation, useNavigate } from "react-router-dom";

import { CurrentUserContext } from "../../App";

import Breadcrumb from "../breadcrumb/breadcrumb";

function AddLabTestData() {
  const { setIsMessage } = useContext(CurrentUserContext);

  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(false);

  const [modeEdit, setModeEdit] = useState(false);

  const [labData, setLabData] = useState({
    lab_type_name: "",
    lab_type_key: "",
    lab_result: [
      {
        lab_name: "",
        lab_key: "",
        lab_code: "",
        objective: "",
        result: [
          {
            result_name: "",
            result_code: "",
            result_key: "",
            testing_result: "",
            interpretation: "",
            recommend_doctor: [{ recommend: "" }],
            recommend_patient: [{ recommend: "" }],
          },
        ],
        method: [
          {
            method_name: "",
            method_code: "",
            method_key: "",
          },
        ],
      },
    ],
  });

  // useEffect(() => {
  //     console.log(labData)
  // }, [labData])

  useEffect(() => {
    if (location?.state?.lab_data) {
      let lab_edit_data = location?.state?.lab_data;
      setModeEdit(true);
      setLabData(transformData(lab_edit_data));
      // console.log(transformData(lab_edit_data));
    }

    function transformData(getdata) {
      return {
        lab_classify_id: getdata.lab_classify_id,
        lab_type_name: getdata.lab_type_name,
        lab_type_key: getdata.lab_type_key,
        lab_result: getdata.lab_result.map((labResult) => {
          return {
            lab_name: labResult.lab_name,
            lab_key: labResult.lab_key,
            lab_code: labResult.lab_code,
            objective: labResult.objective,
            result: labResult.result.map((result) => {
              return {
                result_name: result.result_name,
                result_code: result.result_code,
                result_key: result.result_key,
                testing_result: result.testing_result,
                interpretation: result.interpretation,
                recommend_doctor: result.recommend_doctor.map((doctor) => {
                  return {
                    recommend: doctor,
                  };
                }),
                recommend_patient: result.recommend_patient.map((patient) => {
                  return {
                    recommend: patient,
                  };
                }),
              };
            }),
            method: labResult.method.map((method) => {
              return {
                method_name: method.method_name,
                method_code: method.method_code,
                method_key: method.method_key,
              };
            }),
          };
        }),
      };
    }
  }, []);

  //ไว้แปลงข้อมูลจากเว็บ ไม่เอา recommend key  function นี้ได้ใช้ ในหมวด api add
  function converFilterEmptytData(oldData) {
    const newResult = oldData.lab_result.map((result) => {
      const newResult = result.result.map((r) => {
        const newRecommendDoctor = r.recommend_doctor
          .map((recommend) => {
            return recommend.recommend !== undefined ? recommend.recommend : "";
          })
          .filter((recommend) => recommend !== "");
        const newRecommendPatient = r.recommend_patient
          .map((recommend) => {
            return recommend.recommend !== undefined ? recommend.recommend : "";
          })
          .filter((recommend) => recommend !== "");
        return {
          result_name: r.result_name,
          result_code: r.result_code,
          result_key: r.result_key,
          testing_result: r.testing_result,
          interpretation: r.interpretation,
          recommend_doctor: newRecommendDoctor.length ? newRecommendDoctor : [],
          recommend_patient: newRecommendPatient.length
            ? newRecommendPatient
            : [],
        };
      });
      return {
        lab_name: result.lab_name,
        lab_key: result.lab_key,
        lab_code: result.lab_code,
        objective: result.objective,
        result: newResult,
        method: result.method,
      };
    });
    return {
      lab_type_name: oldData.lab_type_name,
      lab_type_key: oldData.lab_type_key,
      lab_result: newResult,
    };
  }

  //ไว้แปลงข้อมูลจากเว็บ ไม่เอา recommend key  function นี้ได้ใช้ ในหมวด api edit เพราะส่ง lab_classify_id แล้ว
  function converFilterEmptyEdittData(oldData) {
    const newResult = oldData.lab_result.map((result) => {
      const newResult = result.result.map((r) => {
        const newRecommendDoctor = r.recommend_doctor
          .map((recommend) => {
            return recommend.recommend !== undefined ? recommend.recommend : "";
          })
          .filter((recommend) => recommend !== "");
        const newRecommendPatient = r.recommend_patient
          .map((recommend) => {
            return recommend.recommend !== undefined ? recommend.recommend : "";
          })
          .filter((recommend) => recommend !== "");
        return {
          result_name: r.result_name,
          result_code: r.result_code,
          result_key: r.result_key,
          testing_result: r.testing_result,
          interpretation: r.interpretation,
          recommend_doctor: newRecommendDoctor.length ? newRecommendDoctor : [],
          recommend_patient: newRecommendPatient.length
            ? newRecommendPatient
            : [],
        };
      });
      return {
        lab_name: result.lab_name,
        lab_key: result.lab_key,
        lab_code: result.lab_code,
        objective: result.objective,
        result: newResult,
        method: result.method,
      };
    });
    return {
      lab_classify_id: oldData.lab_classify_id,
      lab_type_name: oldData.lab_type_name,
      lab_type_key: oldData.lab_type_key,
      lab_result: newResult,
    };
  }

  // ชื่อชุดการตรวจ (เช่น ยีนแพ้ยา ยีนย่อยสลายยา)
  const handleLabTypeChange = (e) => {
    setLabData({
      ...labData,
      [e.target.name]: e.target.value,
    });
  };

  //รายการตรวจ
  const handleLabResultChange = (e, indx) => {
    const updatedResults = [...labData.lab_result];

    updatedResults[indx][e.target.name] = e.target.value;
    setLabData({
      ...labData,
      lab_result: updatedResults,
    });
  };

  //ผลการตรวจ
  const handleResultTestChange = (LabIndex, resultIndex, e) => {
    const updatedResults = [...labData.lab_result];

    // console.log(resultIndex);
    // console.log(updatedResults[LabIndex].result[resultIndex]);

    //ใช้แบบนี้ได้เลยในกรณีที่ index ในแต่ละ data type
    //เป็นการ set ค่า ที่ index แต่ละ input อยู่
    updatedResults[LabIndex].result[resultIndex][e.target.name] =
      e.target.value;

    setLabData({
      ...labData,
      lab_result: updatedResults,
    });
  };

  //คำแนะนำหมอ
  const handleRecommendDoctorChange = (
    LabIndex,
    resultIndex,
    recommendIndex,
    e,
  ) => {
    const updatedResults = [...labData.lab_result];
    updatedResults[LabIndex].result[resultIndex].recommend_doctor[
      recommendIndex
    ][e.target.name] = e.target.value;
    setLabData({
      ...labData,
      lab_result: updatedResults,
    });
  };

  //ตำแนะนำประชาชน
  const handleRecommendPatientChange = (
    LabIndex,
    resultIndex,
    recommendIndex,
    e,
  ) => {
    const updatedResults = [...labData.lab_result];
    updatedResults[LabIndex].result[resultIndex].recommend_patient[
      recommendIndex
    ][e.target.name] = e.target.value;
    setLabData({
      ...labData,
      lab_result: updatedResults,
    });
  };

  //วิธีการตรวจ
  const handleMethodTestChange = (LabIndex, methodIndex, e) => {
    const updatedResults = [...labData.lab_result];
    updatedResults[LabIndex].method[methodIndex][e.target.name] =
      e.target.value;
    // updatedResults[LabIndex].method = updatedResults[LabIndex].method.map(result => {
    //     result[e.target.name] = e.target.value;
    //     return result;
    // });

    setLabData({
      ...labData,
      lab_result: updatedResults,
    });
  };

  //เพิ่มรายการตรวจใหม่
  const ClickAddListTest = () => {
    const newLabResult = {
      lab_name: "",
      lab_key: "",
      lab_code: "",
      objective: "",
      result: [
        {
          result_name: "",
          result_code: "",
          result_key: "",
          testing_result: "",
          interpretation: "",
          recommend_doctor: [{ recommend: "" }],
          recommend_patient: [{ recommend: "" }],
        },
      ],
      method: [
        {
          method_name: "",
          method_code: "",
          method_key: "",
        },
      ],
    };

    setLabData({
      ...labData,
      lab_result: [...labData.lab_result, newLabResult],
    });
  };

  //เพิ่มผลการตรวจ
  const ClickAddResultTest = (LabIndex) => {
    const newResultTest = {
      result_name: "",
      result_code: "",
      result_key: "",
      testing_result: "",
      interpretation: "",
      recommend_doctor: [{ recommend: "" }],
      recommend_patient: [{ recommend: "" }],
    };
    const updatedResults = [...labData.lab_result];
    updatedResults[LabIndex].result.push(newResultTest);

    setLabData({
      ...labData,
      lab_result: updatedResults,
    });
  };

  //เพิ่มคำแนะนำหมอ
  const ClickAddRecommendDoctor = (LabIndex, resultIndex) => {
    const newRecommendDoctor = { recommend: "" };

    const updatedResults = [...labData.lab_result];
    updatedResults[LabIndex].result[resultIndex].recommend_doctor.push(
      newRecommendDoctor,
    );

    setLabData({
      ...labData,
      lab_result: updatedResults,
    });
  };
  //เพิ่มตำแนะนำประชาชน
  const ClickAddRecommendPatient = (LabIndex, resultIndex) => {
    const newRecommendPatient = { recommend: "" };

    const updatedResults = [...labData.lab_result];
    updatedResults[LabIndex].result[resultIndex].recommend_patient.push(
      newRecommendPatient,
    );

    setLabData({
      ...labData,
      lab_result: updatedResults,
    });
  };

  //เพิ่มวิธีการตรวจ
  const ClickAddMethodTest = (LabIndex) => {
    const newMethodTest = {
      method_name: "",
      method_code: "",
      method_key: "",
    };

    const updatedResults = [...labData.lab_result];
    updatedResults[LabIndex].method.push(newMethodTest);

    setLabData({
      ...labData,
      lab_result: updatedResults,
    });
  };

  //ลบรายการตรวจ
  const removeClickLabResult = (item) => {
    const updatedResults = [...labData.lab_result];
    setLabData({
      ...labData,
      lab_result: updatedResults.filter((remove) => {
        return remove !== item;
      }),
    });
  };

  const removeClickResultTest = (LabIndex, item) => {
    const updatedResults = [...labData.lab_result];
    updatedResults[LabIndex].result = updatedResults[LabIndex].result.filter(
      (remove) => {
        return remove !== item;
      },
    );

    setLabData({
      ...labData,
      lab_result: updatedResults,
    });
  };

  const removeClickMethodTest = (LabIndex, item) => {
    const updatedResults = [...labData.lab_result];
    updatedResults[LabIndex].method = updatedResults[LabIndex].method.filter(
      (remove) => {
        return remove !== item;
      },
    );

    setLabData({
      ...labData,
      lab_result: updatedResults,
    });
  };

  const removeClickRecommendPatient = (LabIndex, resultIndex, item) => {
    const updatedResults = [...labData.lab_result];
    updatedResults[LabIndex].result[resultIndex].recommend_patient =
      updatedResults[LabIndex].result[resultIndex].recommend_patient.filter(
        (remove) => {
          return remove !== item;
        },
      );

    setLabData({
      ...labData,
      lab_result: updatedResults,
    });
  };

  const removeClickRecommendDoctor = (LabIndex, resultIndex, item) => {
    const updatedResults = [...labData.lab_result];
    updatedResults[LabIndex].result[resultIndex].recommend_doctor =
      updatedResults[LabIndex].result[resultIndex].recommend_doctor.filter(
        (remove) => {
          return remove !== item;
        },
      );

    setLabData({
      ...labData,
      lab_result: updatedResults,
    });
  };

  const handleSubmit = () => {
    if (labData.lab_type_name === "") {
      setIsMessage({ type: "warning", data: "กรุณากรอก ชื่อการตรวจภาษาไทย" });
      return;
    }

    if (labData.lab_type_name === "") {
      setIsMessage({
        type: "warning",
        data: "กรุณากรอก ชื่อการตรวจภาษาอังกฤษ",
      });
      return;
    }

    for (let lab_result of labData.lab_result) {
      if (lab_result.lab_name === "") {
        setIsMessage({ type: "warning", data: "กรุณากรอก ชื่อรายการตรวจ" });
        return;
      }

      if (lab_result.lab_code === "") {
        setIsMessage({ type: "warning", data: "กรุณากรอก รหัสการตรวจ" });
        return;
      }

      if (lab_result.lab_key === "") {
        setIsMessage({
          type: "warning",
          data: "กรุณากรอก Key ของชื่อรายการตรวจ",
        });
        return;
      }

      if (lab_result.objective === "") {
        setIsMessage({
          type: "warning",
          data: "กรุณากรอก วัตถุประสงค์ของการตรวจ",
        });
        return;
      }
    }

    for (let lab_result of labData.lab_result) {
      for (let result of lab_result.result) {
        if (result.result_name === "") {
          setIsMessage({ type: "warning", data: "กรุณากรอก ผลการตรวจ" });
          return;
        }

        if (result.result_code === "") {
          setIsMessage({ type: "warning", data: "กรุณากรอก รหัสของผลการตรวจ" });
          return;
        }

        if (result.result_key === "") {
          setIsMessage({ type: "warning", data: "กรุณากรอก Key ของผลการตรวจ" });
          return;
        }

        if (result.testing_result === "") {
          setIsMessage({
            type: "warning",
            data: "กรุณากรอก คำอธิบายผลการตรวจ",
          });
          return;
        }

        if (result.interpretation === "") {
          setIsMessage({ type: "warning", data: "กรุณากรอก การแปลผล" });
          return;
        }

        for (let recommend_doctor of result.recommend_doctor) {
          if (
            recommend_doctor.recommend === "" &&
            result.recommend_doctor.length > 1
          ) {
            setIsMessage({
              type: "warning",
              data: 'กรุณากรอกคำแนะนำ "ฝั่งแพทย์" ให้ครบ',
            });
            return;
          }
        }
        for (let recommend_patient of result.recommend_patient) {
          if (
            recommend_patient.recommend === "" &&
            result.recommend_patient.length > 1
          ) {
            setIsMessage({
              type: "warning",
              data: 'กรุณากรอกคำแนะนำ "ฝั่งประชาชน" ให้ครบ',
            });
            return;
          }
        }
      }
      for (let method of lab_result.method) {
        if (method.method_name === "") {
          setIsMessage({ type: "warning", data: "กรุณากรอก วิธีการตรวจ" });
          return;
        }

        if (method.method_code === "") {
          setIsMessage({
            type: "warning",
            data: "กรุณากรอก Key ของวิธีการตรวจ",
          });
          return;
        }

        if (method.method_key === "") {
          setIsMessage({
            type: "warning",
            data: "กรุณากรอก รหัสของวิธีการตรวจ",
          });
          return;
        }
      }
    }

    // console.log(labData, "ดาต้าเดิม");

    const newData = converFilterEmptytData(labData);
    // console.log(newData);

    //post add api lab
    AddLabClassify(newData);
  };

  const AddLabClassify = async (lab_data) => {
    setLoading(true);
    let res = await AdminApi.addLabClassify(lab_data);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({
          type: "success",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
        navigate("/managewebsite/add-lab-test-kid", {
          state: {
            option: "2",
          },
        });
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const handleEditSubmit = () => {
    if (labData.lab_type_name === "") {
      setIsMessage({ type: "warning", data: "กรุณากรอก ชื่อการตรวจภาษาไทย" });
      return;
    }

    if (labData.lab_type_name === "") {
      setIsMessage({
        type: "warning",
        data: "กรุณากรอก ชื่อการตรวจภาษาอังกฤษ",
      });
      return;
    }

    for (let lab_result of labData.lab_result) {
      if (lab_result.lab_name === "") {
        setIsMessage({ type: "warning", data: "กรุณากรอก ชื่อรายการตรวจ" });
        return;
      }

      if (lab_result.lab_code === "") {
        setIsMessage({ type: "warning", data: "กรุณากรอก รหัสการตรวจ" });
        return;
      }

      if (lab_result.lab_key === "") {
        setIsMessage({
          type: "warning",
          data: "กรุณากรอก Key ของชื่อรายการตรวจ",
        });
        return;
      }

      if (lab_result.objective === "") {
        setIsMessage({
          type: "warning",
          data: "กรุณากรอก วัตถุประสงค์ของการตรวจ",
        });
        return;
      }
    }

    for (let lab_result of labData.lab_result) {
      for (let result of lab_result.result) {
        if (result.result_name === "") {
          setIsMessage({ type: "warning", data: "กรุณากรอก ผลการตรวจ" });
          return;
        }

        if (result.result_code === "") {
          setIsMessage({ type: "warning", data: "กรุณากรอก รหัสของผลการตรวจ" });
          return;
        }

        if (result.result_key === "") {
          setIsMessage({ type: "warning", data: "กรุณากรอก Key ของผลการตรวจ" });
          return;
        }

        if (result.testing_result === "") {
          setIsMessage({
            type: "warning",
            data: "กรุณากรอก คำอธิบายผลการตรวจ",
          });
          return;
        }

        if (result.interpretation === "") {
          setIsMessage({ type: "warning", data: "กรุณากรอก การแปลผล" });
          return;
        }

        for (let recommend_doctor of result.recommend_doctor) {
          if (
            recommend_doctor.recommend === "" &&
            result.recommend_doctor.length > 1
          ) {
            setIsMessage({
              type: "warning",
              data: 'กรุณากรอก คำแนะนำ "ฝั่งแพทย์" ให้ครบ',
            });
            return;
          }
        }
        for (let recommend_patient of result.recommend_patient) {
          if (
            recommend_patient.recommend === "" &&
            result.recommend_patient.length > 1
          ) {
            setIsMessage({
              type: "warning",
              data: 'กรุณากรอก คำแนะนำ "ฝั่งประชาชน" ให้ครบ',
            });
            return;
          }
        }
      }
      for (let method of lab_result.method) {
        if (method.method_name === "") {
          setIsMessage({ type: "warning", data: "กรุณากรอก วิธีการตรวจ" });
          return;
        }

        if (method.method_code === "") {
          setIsMessage({
            type: "warning",
            data: "กรุณากรอก Key ของวิธีการตรวจ",
          });
          return;
        }

        if (method.method_key === "") {
          setIsMessage({
            type: "warning",
            data: "กรุณากรอก รหัสของวิธีการตรวจ",
          });
          return;
        }
      }
    }

    // console.log(labData, "ดาต้าเดิม edit");

    const newData = converFilterEmptyEdittData(labData);
    UpdateLabClassify(newData);
  };

  const UpdateLabClassify = async (lab_data) => {
    setLoading(true);
    let res = await AdminApi.updateLabClassify(lab_data);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({
          type: "success",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
        navigate("/managewebsite/add-lab-test-kid", {
          state: {
            option: "2",
          },
        });
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  let css_styles = {
    text_delete_form:
      "text-[#E85151] underline underline-offset-2 hover:cursor-pointer hover:font-bold transition transform hover:-translate-y-1 duration-[400ms] motion-reduce:transition-none motion-reduce:hover:transform-none",
    btn_add:
      "button-theme-pg bg-gradient-to-r from-[#85DDDE] to-[#B9DFC5] rounded-3xl shadow-sm shadow-brand-cyan flex justify-center items-center text-[16px] h-[40px] gap-[10px] text-[#000000]  ",
    grid_cols_four:
      "grid grid-cols-[20px_auto_40px_40px] items-center gap-[10px] my-2",
    icon_plus:
      "button-theme-pg  bg-gradient-to-r from-[#85DDDE] to-[#B9DFC5] p-2 rounded-full stroke-[#526F65] stroke-[3px]  m-auto hover:cursor-pointer",
    icon_delete:
      "button-theme-pg  bg-[#EA8D8D] p-2 rounded-full stroke-[#374957] stroke-[3px] m-auto  hover:cursor-pointer",
  };

  const pathItems = [
    { name: "หน้าหลัก", url: "/" },
    { name: "จัดการข้อมูลเว็บไซด์", url: "/managewebsite" },
    { name: "เพิ่มข้อมูลชุดตรวจแลป", url: "/managewebsite/add-lab-test-kid" },
    {
      name: "เพิ่มชุดการตรวจแลปในระบบ",
      url: "/managewebsite/add-lab-test-kid/add-edit-lab-test-kid-data",
    },
  ];

  return (
    <div className="global-page">
      <MenuAdmin menuActive="managewebsite" />
      <Breadcrumb pathItems={pathItems} />
      <PageHeader
        option={"2"}
        titlename={
          modeEdit ? "แก้ไขชุดการตรวจแลปในระบบ" : "เพิ่มชุดการตรวจแลปในระบบ"
        }
        backpath={"/managewebsite/add-lab-test-kid"}
        btnBackWard
      />
      <div className={styles.container}>
        <div className={styles.textAlign}>
          <div className={styles.textBack}>ชื่อชุดการตรวจ</div>
          <div className={styles.textOrange}>(เช่น ยีนแพ้ยา ยีนย่อยสลายยา)</div>
        </div>
        <div className={styles.alignAll}>
          <Input
            classNameLabel="text-[#000000] font-medium text-[14px]"
            placeholder="ชื่อการตรวจภาษาไทย"
            name="lab_type_name"
            value={labData.lab_type_name}
            validate={labData.lab_type_name === "" ? true : false}
            onChangeEvt={(e) => {
              handleLabTypeChange(e);
            }}
          />
          <Input
            classNameLabel="text-[#000000] font-medium text-[14px]"
            placeholder="ชื่อการตรวจภาษาอังกฤษ"
            validate={labData.lab_type_key === "" ? true : false}
            name="lab_type_key"
            value={labData.lab_type_key}
            onChangeEvt={(e) => {
              handleLabTypeChange(e);
            }}
          />
        </div>
        <hr className={styles.hrLine} />
        {labData.lab_result.map((item, indx) => {
          return (
            <div key={indx} className={styles.alignYellow}>
              <div className="flex gap-5 mb-6">
                <div className={styles.textBack}>
                  ชื่อรายการตรวจที่ {indx + 1}
                </div>
                {labData.lab_result.length > 1 ? (
                  <div
                    onClick={() => {
                      if (
                        window.confirm(
                          `ยืนยันลบรายการตรวจที่ ${indx + 1} ลบหรือไม่`,
                        )
                      ) {
                        removeClickLabResult(item);
                      }
                    }}
                    className={css_styles.text_delete_form}
                  >
                    ลบรายการตรวจนี้
                  </div>
                ) : null}
              </div>
              <div className={styles.alignAllInput}>
                <Input
                  classNameLabel="text-[#000000] font-medium text-[14px]"
                  name="lab_name"
                  label="ชื่อรายการตรวจ (เช่น การตรวจ HLA-B*15:02 อัลลีล)"
                  placeholder="ชื่อรายการตรวจ"
                  validate={item.lab_name === "" ? true : false}
                  value={item.lab_name}
                  onChangeEvt={(e) => {
                    handleLabResultChange(e, indx);
                  }}
                />
                <Input
                  classNameLabel="text-[#000000] font-medium text-[14px]"
                  name="lab_key"
                  label="Key ของชื่อรายการตรวจ (เช่น hla-b*15:02)"
                  placeholder="Key ชื่อการตรวจแบบย่อ"
                  validate={item.lab_key === "" ? true : false}
                  value={item.lab_key}
                  onChangeEvt={(e) => {
                    handleLabResultChange(e, indx);
                  }}
                />
                <Input
                  classNameLabel="text-[#000000] font-medium text-[14px]"
                  name="lab_code"
                  placeholder="รหัสการตรวจ"
                  validate={item.lab_code === "" ? true : false}
                  value={item.lab_code}
                  onChangeEvt={(e) => {
                    handleLabResultChange(e, indx);
                  }}
                />
                <Input
                  classNameLabel="text-[#000000] font-medium text-[14px]"
                  name="objective"
                  placeholder="วัตถุประสงค์ของการตรวจ"
                  validate={item.objective === "" ? true : false}
                  value={item.objective}
                  onChangeEvt={(e) => {
                    handleLabResultChange(e, indx);
                  }}
                />
              </div>
              {item.result.map((item_result, indx_result) => {
                return (
                  <div key={indx_result}>
                    <hr className={styles.hr} />
                    <div className="flex gap-5 mb-6">
                      <div className={styles.textBack}>
                        ผลการตรวจที่ {indx_result + 1}
                      </div>
                      {item.result.length > 1 ? (
                        <div
                          onClick={() => {
                            removeClickResultTest(indx, item_result);
                          }}
                          className={css_styles.text_delete_form}
                        >
                          ลบผลการตรวจนี้
                        </div>
                      ) : null}
                    </div>
                    <div className={styles.alignAllInput}>
                      <Input
                        classNameLabel="text-[#000000] font-medium text-[14px]"
                        name="result_name"
                        label="ผลการตรวจ (เช่น Positive, Negative)"
                        placeholder="ผลการตรวจ"
                        validate={item_result.result_name === "" ? true : false}
                        value={item_result.result_name}
                        onChangeEvt={(e) => {
                          handleResultTestChange(indx, indx_result, e);
                        }}
                      />
                      <Input
                        classNameLabel="text-[#000000] font-medium text-[14px]"
                        name="result_key"
                        label="Key ของผลการตรวจ"
                        placeholder="Key ผลการตรวจแบบย่อ"
                        validate={item_result.result_key === "" ? true : false}
                        value={item_result.result_key}
                        onChangeEvt={(e) => {
                          handleResultTestChange(indx, indx_result, e);
                        }}
                      />
                    </div>
                    <div className="mb-[20px]">
                      <Input
                        classNameLabel="text-[#000000] font-medium text-[14px]"
                        name="testing_result"
                        label="คำอธิบายผลการตรวจ (เช่น มี HLA-B* 58:01 อัลลีล)"
                        placeholder="คำอธิบายผลการตรวจ"
                        validate={
                          item_result.testing_result === "" ? true : false
                        }
                        value={item_result.testing_result}
                        onChangeEvt={(e) => {
                          handleResultTestChange(indx, indx_result, e);
                        }}
                      />
                    </div>
                    <div className={styles.alignAllInput}>
                      <Input
                        classNameLabel="text-[#000000] font-medium text-[14px]"
                        name="result_code"
                        placeholder="รหัสของผลการตรวจ"
                        validate={item_result.result_code === "" ? true : false}
                        value={item_result.result_code}
                        onChangeEvt={(e) => {
                          handleResultTestChange(indx, indx_result, e);
                        }}
                      />
                      <Input
                        classNameLabel="text-[#000000] font-medium text-[14px]"
                        name="interpretation"
                        placeholder="การแปลผล"
                        validate={
                          item_result.interpretation === "" ? true : false
                        }
                        value={item_result.interpretation}
                        onChangeEvt={(e) => {
                          handleResultTestChange(indx, indx_result, e);
                        }}
                      />
                    </div>
                    <div className={styles.text}>คำแนะนำฝั่งประชาชน</div>
                    {item_result.recommend_patient.map((i, idx) => {
                      return (
                        <div key={idx} className={css_styles.grid_cols_four}>
                          <div>{idx + 1} .</div>
                          <Input
                            name="recommend"
                            validate={
                              i.recommend === "" &&
                              item_result.recommend_patient.length > 1
                            }
                            value={i.recommend}
                            disabledLabel
                            placeholder="คำแนะนำ / LINK"
                            onChangeEvt={(e) => {
                              handleRecommendPatientChange(
                                indx,
                                indx_result,
                                idx,
                                e,
                              );
                            }}
                          />
                          {item_result.recommend_patient.length !== 1 && (
                            <MinusIcon
                              className={css_styles.icon_delete}
                              onClick={() => {
                                removeClickRecommendPatient(
                                  indx,
                                  indx_result,
                                  i,
                                );
                              }}
                            />
                          )}
                          {item_result.recommend_patient.length - 1 === idx && (
                            <PlusIcon
                              className={css_styles.icon_plus}
                              onClick={() => {
                                ClickAddRecommendPatient(indx, indx_result);
                              }}
                            />
                          )}
                        </div>
                      );
                    })}
                    <div className={styles.text}>คำแนะนำฝั่งแพทย์</div>
                    {item_result.recommend_doctor.map((i, idx) => {
                      return (
                        <div key={idx} className={css_styles.grid_cols_four}>
                          <div>{idx + 1} .</div>
                          <Input
                            name="recommend"
                            validate={
                              i.recommend === "" &&
                              item_result.recommend_doctor.length > 1
                            }
                            value={i.recommend}
                            disabledLabel
                            placeholder="คำแนะนำ / LINK"
                            onChangeEvt={(e) => {
                              handleRecommendDoctorChange(
                                indx,
                                indx_result,
                                idx,
                                e,
                              );
                            }}
                          />
                          {item_result.recommend_doctor.length !== 1 && (
                            <MinusIcon
                              className={css_styles.icon_delete}
                              onClick={() => {
                                removeClickRecommendDoctor(
                                  indx,
                                  indx_result,
                                  i,
                                );
                              }}
                            />
                          )}
                          {item_result.recommend_doctor.length - 1 === idx && (
                            <PlusIcon
                              className={css_styles.icon_plus}
                              onClick={() => {
                                ClickAddRecommendDoctor(indx, indx_result);
                              }}
                            />
                          )}
                        </div>
                      );
                    })}
                  </div>
                );
              })}
              <div className={styles.buttonAlign} style={{ marginTop: "20px" }}>
                <button
                  className={css_styles.btn_add}
                  onClick={() => {
                    ClickAddResultTest(indx);
                  }}
                >
                  <img src={plusSmall} />
                  <div>เพิ่มผลการตรวจอื่น</div>
                </button>
              </div>
              <hr className={styles.hr} />
              {item.method.map((item_method, indx_method) => {
                return (
                  <div key={indx_method}>
                    <div className="flex gap-5 mb-6">
                      <div className={styles.textBack}>
                        วิธีการตรวจที่ {indx_method + 1}
                      </div>
                      {item.method.length > 1 ? (
                        <div
                          onClick={() => {
                            removeClickMethodTest(indx, item_method);
                          }}
                          className={css_styles.text_delete_form}
                        >
                          ลบวิธีการตรวจนี้
                        </div>
                      ) : null}
                    </div>

                    <div className={styles.alignAllInput}>
                      <Input
                        classNameLabel="text-[#000000] font-medium text-[14px]"
                        name="method_name"
                        label="วิธีการตรวจ (เช่น Real-time PCR)"
                        placeholder="วิธีการตรวจ"
                        validate={item_method.method_name === "" ? true : false}
                        value={item_method.method_name}
                        onChangeEvt={(e) => {
                          handleMethodTestChange(indx, indx_method, e);
                        }}
                      />
                      <Input
                        classNameLabel="text-[#000000] font-medium text-[14px]"
                        name="method_key"
                        label="Key ของวิธีการตรวจ (เช่น realtime_PCR)"
                        placeholder="Key ของวิธีการตรวจ"
                        validate={item_method.method_key === "" ? true : false}
                        value={item_method.method_key}
                        onChangeEvt={(e) => {
                          handleMethodTestChange(indx, indx_method, e);
                        }}
                      />
                      <Input
                        classNameLabel="text-[#000000] font-medium text-[14px]"
                        name="method_code"
                        placeholder="รหัสของวิธีการตรวจ"
                        validate={item_method.method_code === "" ? true : false}
                        value={item_method.method_code}
                        onChangeEvt={(e) => {
                          handleMethodTestChange(indx, indx_method, e);
                        }}
                      />
                    </div>
                  </div>
                );
              })}
              <div className={styles.buttonAlign} style={{ marginTop: "20px" }}>
                <button
                  className={css_styles.btn_add}
                  onClick={() => {
                    ClickAddMethodTest(indx);
                  }}
                >
                  <img src={plusSmall} />
                  <div>เพิ่มวิธีการตรวจอื่น</div>
                </button>
              </div>
            </div>
          );
        })}
        <div className={styles.buttonAlign} style={{ margin: "20px 0px" }}>
          <button
            className={css_styles.btn_add}
            onClick={() => {
              ClickAddListTest();
            }}
          >
            <img src={plusSmall} />
            <div>เพิ่มชื่อรายการตรวจอื่น ๆ</div>
          </button>
        </div>
        <div className={styles.alignGreen}>
          <div style={{ textAlign: "center" }}>
            <div className={styles.textOrange}>
              **กรุณาตรวจสอบข้อมูลให้ถูกต้องก่อนทำการบันทึก**
            </div>
            <div className={styles.buttonAlign} style={{ marginTop: "20px" }}>
              <button
                className={css_styles.btn_add}
                onClick={() => {
                  modeEdit ? handleEditSubmit() : handleSubmit();
                }}
              >
                <div className="font-bold text-[20px]">
                  {modeEdit ? "บันทึกการแก้ไข" : "บันทึกชุดการตรวจ"}
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default AddLabTestData;
